import { WORK_ITEMS } from "@/lib/content/work";
import {
  CONNECTED_SYSTEMS_FULL_TAGLINE,
  GROWTH_SERVICE_FULL_TAGLINE,
  MEDICAL_SYSTEMS_FULL_TAGLINE,
} from "@/lib/content/service-configs";
import { sortDigitalExperiencesWork } from "@/lib/work-display-order";

type WorkItem = (typeof WORK_ITEMS)[number];

export const WORK_CATEGORY_DESCRIPTIONS: Readonly<Record<string, string>> = {
  all: "We partner with ambitious teams to create impactful digital products and experiences.",
  "connected-systems": CONNECTED_SYSTEMS_FULL_TAGLINE,
  "digital-experiences": GROWTH_SERVICE_FULL_TAGLINE,
  "ai-consulting":
    "We harness the power of AI and rapid prototyping to accelerate innovation and build intelligent solutions.",
  "medical-devices": MEDICAL_SYSTEMS_FULL_TAGLINE,
};

export function filterAndSortWork(
  items: readonly WorkItem[],
  category: string,
): WorkItem[] {
  const filtered = items.filter((item) => {
    if (!item.listed) return false;
    if (category === "all") return true;
    return item.categories?.includes(category);
  });

  return category === "digital-experiences"
    ? sortDigitalExperiencesWork(filtered)
    : filtered;
}
